module.exports = __webpack_public_path__ + "img/location_black.fb7caa34.svg";